import LegalPage from "../components/LegalPage/LegalPage";
import legalDocuments from "../content/legalDocuments";
import { useLanguage } from "../contexts/LanguageContext";

const PrivacyPolicy = () => {
  const { language } = useLanguage();
  const document = legalDocuments[language] || legalDocuments.en;

  return <LegalPage kind="privacy" {...document.privacy} />;
};

export default PrivacyPolicy;
